export const EVENTS = {
  AUTHORIZE_VIEW: 'authorize-view',
  AUTHORIZE_ALERT_VIEW: 'authorize-alert-view',
  VERIFIED_DOMAIN_CLICK: 'verified-domain-click',
  APP_INSTALLED: 'app-installed',
  INSTALL_FLOW_CANCELED: 'install-flow-canceled'
};